import React from 'react';
import { Skeleton } from '@yme/common/components/skeletons';
export function OrderSummarySkeleton() {
    return (React.createElement(Skeleton, { skeletonProps: {
            height: 482,
        }, wrapperProps: {
            mlS: -16,
            mrS: -16,
            mtS: 24,
            mlM: 0,
            mrM: 0,
            mlL: 24,
            mtL: 0,
        } }));
}
